export default class NotFoundModel {
  title
  content
  constructor () {
    this.title = '404 Error'
    this.content = 'The page you have requested does not exist'
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/NotFoundModel.js